/**
 * tokenStore — singleton in-memory token storage.
 *
 * In-memory only per spec — page refresh loses tokens, requires Identity re-auth.
 * Subscribers are notified on token changes (used by AuthContext to re-render).
 *
 * Used outside React via getAccessToken() — needed for axios interceptor +
 * all fetch callsites that need to attach Authorization headers.
 *
 * v18.1.6 — De voormalige `localStorage.getItem('auth_token')` shim is
 * VERWIJDERD. Reden: WebKit (iOS Safari + Chrome-on-iOS) negeert silently
 * het overschrijven van `window.localStorage.getItem` als instance method,
 * waardoor pagina's die de shim gebruikten op iOS `null` ontvingen ipv het
 * in-memory token → Authorization header werd niet correct meegestuurd →
 * alle endpoints met `require_auth*` faalden op echte iPhones.
 *
 * Alle callsites zijn gemigreerd naar het canonical pattern:
 *   import { getAccessToken } from '@/lib/tokenStore';
 *   const t = getAccessToken();
 */
let _accessToken = null;
let _refreshToken = null;
const _subscribers = new Set();

export const getAccessToken = () => _accessToken;
export const getRefreshToken = () => _refreshToken;

export const setTokens = (access, refresh) => {
  _accessToken = access || null;
  _refreshToken = refresh || null;
  _subscribers.forEach(fn => { try { fn(); } catch {} });
};

export const clearTokens = () => setTokens(null, null);

export const subscribe = (fn) => {
  _subscribers.add(fn);
  return () => _subscribers.delete(fn);
};

// Wipe any leftover localStorage entry from before the v18.0 cutover.
// Belt-and-braces: also remove on every page load in case a stale value
// somehow ended up there. Failures (private mode, disabled storage) are
// silently swallowed — we never depend on localStorage for the token.
if (typeof window !== 'undefined' && window.localStorage) {
  try { window.localStorage.removeItem('auth_token'); } catch {}
}
